export const QuizStatuses = {
  HAS_NOT_TRIED: "Hasn't tried",
  ATTEMPT1: 'Attempt 1',
  ATTEMPT2: 'Attempt 2',
  PASSED: 'Passed',
};
